module.exports = __webpack_public_path__ + "img/arrow_down.75324a79.svg";